import * as React from "react";
import {useContext, useEffect, useRef} from "react";
import {TokenContext} from "../../Context/TokenContext";
import {useNavigate} from "react-router";

export function Authentication(props) {
    const {accessToken, setCode, setFinishProcess,finishProcess} = useContext(TokenContext)
    const params = new URLSearchParams(window.location.search);


    // Convertir tous les paramètres en objet
    const paramsObject = Object.fromEntries(params.entries());
    const navigate = useNavigate();
    // paramsObject est recréé à chaque rendu : sans ce verrou, l'effet se
    // redéclenche à chaque re-render survenant avant que accessToken/finishProcess
    // ne soient mis à jour, et échange le même code plusieurs fois (il est
    // à usage unique côté oauth2, donc les tentatives suivantes échouent).
    const codeExchangeStarted = useRef(false);

    useEffect(() => {
        if (paramsObject?.code && !accessToken && !finishProcess && !codeExchangeStarted.current) {
            codeExchangeStarted.current = true;
            setCode(paramsObject.code, paramsObject.state)
        }
    }, [paramsObject, finishProcess, accessToken])


    useEffect(() => {
        if (!!accessToken) {
            setFinishProcess(true)
            navigate('/')
        }
    }, [accessToken])


    return (
        <></>
    )

}
